export default __webpack_public_path__ + "static/media/media.f30dfd09.svg";